/**
 * Tüm marketing / auth / hakkımızda / iletişim sayfalarında aynı üst bar.
 * @see MarketingNavbar
 */
import MarketingNavbar from "./marketing/MarketingNavbar";

export default function TopBarOfMarketing({ darkMode, setDarkMode }) {
  void darkMode;
  void setDarkMode;
  return <MarketingNavbar />;
}
